import Component from '@glimmer/component';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

type AmountCents = number | string | null | undefined;

interface CurrencySuperscriptCentsSignature {
  Args: {
    amountCents?: AmountCents;
  };
  Element: HTMLSpanElement;
}

export default class CurrencySuperscriptCents extends Component<CurrencySuperscriptCentsSignature> {
  @service declare intl: IntlService;

  get formattedParts() {
    const amount = this.args.amountCents;

    if (amount === null || amount === undefined || amount === '') {
      return null;
    }

    const amountNumber = typeof amount === 'string' ? Number.parseInt(amount, 10) : amount;
    const formattedParts = new Intl.NumberFormat(this.intl.primaryLocale, {
      style: 'currency',
      currency: 'USD',
    }).formatToParts(amountNumber / 100);

    let leading = '';
    let cents = '';
    let trailing = '';
    let foundCents = false;

    for (const part of formattedParts) {
      if (part.type === 'fraction') {
        cents += part.value;
        foundCents = true;
      } else if (part.type !== 'decimal') {
        if (foundCents) {
          trailing += part.value;
        } else {
          leading += part.value;
        }
      }
    }

    return { leading, cents, trailing };
  }

  <template>
    {{#let this.formattedParts as |parts|}}
      {{#if parts}}
        <span class="inline-flex items-start leading-none" ...attributes>{{parts.leading}}<span
            class="text-[0.55em] pt-[0.1em]"
          >{{parts.cents}}</span>{{parts.trailing}}</span>
      {{/if}}
    {{/let}}
  </template>
}
